// source: pangolin/protos/issues.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */


var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.pangolin.protos.GetIssueIncidentResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.GetIssueIncidentsResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.GetIssueResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.GetIssuesResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.IssueError', null, global);
goog.exportSymbol('proto.pangolin.protos.IssueErrorMap', null, global);
goog.exportSymbol('proto.pangolin.protos.IssueErrorMapTuple', null, global);
goog.exportSymbol('proto.pangolin.protos.IssueIncidentError', null, global);
goog.exportSymbol('proto.pangolin.protos.IssueIncidentErrorMap', null, global);
goog.exportSymbol('proto.pangolin.protos.IssueIncidentErrorMapTuple', null, global);
goog.exportSymbol('proto.pangolin.protos.IssueIncidentObject', null, global);
goog.exportSymbol('proto.pangolin.protos.IssueIncidentObjectMap', null, global);
goog.exportSymbol('proto.pangolin.protos.IssueIncidentObjectMapTuple', null, global);
goog.exportSymbol('proto.pangolin.protos.IssueObject', null, global);
goog.exportSymbol('proto.pangolin.protos.IssueObjectMap', null, global);
goog.exportSymbol('proto.pangolin.protos.IssueObjectMapTuple', null, global);
goog.exportSymbol('proto.pangolin.protos.SetIssueIncidentRequest', null, global);
goog.exportSymbol('proto.pangolin.protos.SetIssueIncidentResponseInvalid', null, global);
goog.exportSymbol('proto.pangolin.protos.SetIssueIncidentsRequest', null, global);
goog.exportSymbol('proto.pangolin.protos.SetIssueIncidentsResponseInvalid', null, global);
goog.exportSymbol('proto.pangolin.protos.SetIssueRequest', null, global);
goog.exportSymbol('proto.pangolin.protos.SetIssueResponseInvalid', null, global);
goog.exportSymbol('proto.pangolin.protos.SetIssuesRequest', null, global);
goog.exportSymbol('proto.pangolin.protos.SetIssuesResponseInvalid', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.IssueIncidentObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.IssueIncidentObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.IssueIncidentObject.displayName = 'proto.pangolin.protos.IssueIncidentObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.IssueIncidentObjectMap = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.IssueIncidentObjectMap.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.IssueIncidentObjectMap, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.IssueIncidentObjectMap.displayName = 'proto.pangolin.protos.IssueIncidentObjectMap';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.IssueIncidentObjectMapTuple = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.IssueIncidentObjectMapTuple, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.IssueIncidentObjectMapTuple.displayName = 'proto.pangolin.protos.IssueIncidentObjectMapTuple';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.IssueObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.IssueObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.IssueObject.displayName = 'proto.pangolin.protos.IssueObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.IssueObjectMap = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.IssueObjectMap.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.IssueObjectMap, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.IssueObjectMap.displayName = 'proto.pangolin.protos.IssueObjectMap';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.IssueObjectMapTuple = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.IssueObjectMapTuple, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.IssueObjectMapTuple.displayName = 'proto.pangolin.protos.IssueObjectMapTuple';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.IssueIncidentError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.IssueIncidentError.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.IssueIncidentError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.IssueIncidentError.displayName = 'proto.pangolin.protos.IssueIncidentError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.IssueIncidentErrorMap = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.IssueIncidentErrorMap.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.IssueIncidentErrorMap, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.IssueIncidentErrorMap.displayName = 'proto.pangolin.protos.IssueIncidentErrorMap';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.IssueIncidentErrorMapTuple = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.IssueIncidentErrorMapTuple, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.IssueIncidentErrorMapTuple.displayName = 'proto.pangolin.protos.IssueIncidentErrorMapTuple';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.IssueError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.IssueError.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.IssueError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.IssueError.displayName = 'proto.pangolin.protos.IssueError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.IssueErrorMap = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.IssueErrorMap.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.IssueErrorMap, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.IssueErrorMap.displayName = 'proto.pangolin.protos.IssueErrorMap';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.IssueErrorMapTuple = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.IssueErrorMapTuple, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.IssueErrorMapTuple.displayName = 'proto.pangolin.protos.IssueErrorMapTuple';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.GetIssuesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.GetIssuesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.GetIssuesResponse.displayName = 'proto.pangolin.protos.GetIssuesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SetIssuesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SetIssuesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SetIssuesRequest.displayName = 'proto.pangolin.protos.SetIssuesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SetIssuesResponseInvalid = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SetIssuesResponseInvalid, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SetIssuesResponseInvalid.displayName = 'proto.pangolin.protos.SetIssuesResponseInvalid';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.GetIssueResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.GetIssueResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.GetIssueResponse.displayName = 'proto.pangolin.protos.GetIssueResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SetIssueRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SetIssueRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SetIssueRequest.displayName = 'proto.pangolin.protos.SetIssueRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SetIssueResponseInvalid = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SetIssueResponseInvalid, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SetIssueResponseInvalid.displayName = 'proto.pangolin.protos.SetIssueResponseInvalid';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.GetIssueIncidentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.GetIssueIncidentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.GetIssueIncidentsResponse.displayName = 'proto.pangolin.protos.GetIssueIncidentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SetIssueIncidentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SetIssueIncidentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SetIssueIncidentsRequest.displayName = 'proto.pangolin.protos.SetIssueIncidentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SetIssueIncidentsResponseInvalid = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SetIssueIncidentsResponseInvalid, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SetIssueIncidentsResponseInvalid.displayName = 'proto.pangolin.protos.SetIssueIncidentsResponseInvalid';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.GetIssueIncidentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.GetIssueIncidentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.GetIssueIncidentResponse.displayName = 'proto.pangolin.protos.GetIssueIncidentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SetIssueIncidentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SetIssueIncidentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SetIssueIncidentRequest.displayName = 'proto.pangolin.protos.SetIssueIncidentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SetIssueIncidentResponseInvalid = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SetIssueIncidentResponseInvalid, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SetIssueIncidentResponseInvalid.displayName = 'proto.pangolin.protos.SetIssueIncidentResponseInvalid';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.IssueIncidentObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.IssueIncidentObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.IssueIncidentObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.IssueIncidentObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    uuid: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    timestamp: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    seen: (f = jspb.Message.getBooleanField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.IssueIncidentObject}
 */
proto.pangolin.protos.IssueIncidentObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.IssueIncidentObject;
  return proto.pangolin.protos.IssueIncidentObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.IssueIncidentObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.IssueIncidentObject}
 */
proto.pangolin.protos.IssueIncidentObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimestamp(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSeen(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.IssueIncidentObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.IssueIncidentObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.IssueIncidentObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.IssueIncidentObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.pangolin.protos.IssueIncidentObject.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.IssueIncidentObject} returns this
 */
proto.pangolin.protos.IssueIncidentObject.prototype.setUuid = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.IssueIncidentObject} returns this
 */
proto.pangolin.protos.IssueIncidentObject.prototype.clearUuid = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.IssueIncidentObject.prototype.hasUuid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string timestamp = 2;
 * @return {string}
 */
proto.pangolin.protos.IssueIncidentObject.prototype.getTimestamp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.IssueIncidentObject} returns this
 */
proto.pangolin.protos.IssueIncidentObject.prototype.setTimestamp = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.IssueIncidentObject} returns this
 */
proto.pangolin.protos.IssueIncidentObject.prototype.clearTimestamp = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.IssueIncidentObject.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool seen = 3;
 * @return {boolean}
 */
proto.pangolin.protos.IssueIncidentObject.prototype.getSeen = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.IssueIncidentObject} returns this
 */
proto.pangolin.protos.IssueIncidentObject.prototype.setSeen = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.IssueIncidentObject} returns this
 */
proto.pangolin.protos.IssueIncidentObject.prototype.clearSeen = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.IssueIncidentObject.prototype.hasSeen = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.IssueIncidentObjectMap.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.IssueIncidentObjectMap.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.IssueIncidentObjectMap.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.IssueIncidentObjectMap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.IssueIncidentObjectMap.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.pangolin.protos.IssueIncidentObjectMapTuple.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.IssueIncidentObjectMap}
 */
proto.pangolin.protos.IssueIncidentObjectMap.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.IssueIncidentObjectMap;
  return proto.pangolin.protos.IssueIncidentObjectMap.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.IssueIncidentObjectMap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.IssueIncidentObjectMap}
 */
proto.pangolin.protos.IssueIncidentObjectMap.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.IssueIncidentObjectMapTuple;
      reader.readMessage(value,proto.pangolin.protos.IssueIncidentObjectMapTuple.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.IssueIncidentObjectMap.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.IssueIncidentObjectMap.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.IssueIncidentObjectMap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.IssueIncidentObjectMap.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pangolin.protos.IssueIncidentObjectMapTuple.serializeBinaryToWriter
    );
  }
};


/**
 * repeated IssueIncidentObjectMapTuple items = 1;
 * @return {!Array<!proto.pangolin.protos.IssueIncidentObjectMapTuple>}
 */
proto.pangolin.protos.IssueIncidentObjectMap.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.pangolin.protos.IssueIncidentObjectMapTuple>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pangolin.protos.IssueIncidentObjectMapTuple, 1));
};


/**
 * @param {!Array<!proto.pangolin.protos.IssueIncidentObjectMapTuple>} value
 * @return {!proto.pangolin.protos.IssueIncidentObjectMap} returns this
*/
proto.pangolin.protos.IssueIncidentObjectMap.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pangolin.protos.IssueIncidentObjectMapTuple=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.IssueIncidentObjectMapTuple}
 */
proto.pangolin.protos.IssueIncidentObjectMap.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pangolin.protos.IssueIncidentObjectMapTuple, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.IssueIncidentObjectMap} returns this
 */
proto.pangolin.protos.IssueIncidentObjectMap.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.IssueIncidentObjectMapTuple.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.IssueIncidentObjectMapTuple.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.IssueIncidentObjectMapTuple} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.IssueIncidentObjectMapTuple.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    data: (f = msg.getData()) && proto.pangolin.protos.IssueIncidentObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.IssueIncidentObjectMapTuple}
 */
proto.pangolin.protos.IssueIncidentObjectMapTuple.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.IssueIncidentObjectMapTuple;
  return proto.pangolin.protos.IssueIncidentObjectMapTuple.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.IssueIncidentObjectMapTuple} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.IssueIncidentObjectMapTuple}
 */
proto.pangolin.protos.IssueIncidentObjectMapTuple.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.pangolin.protos.IssueIncidentObject;
      reader.readMessage(value,proto.pangolin.protos.IssueIncidentObject.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.IssueIncidentObjectMapTuple.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.IssueIncidentObjectMapTuple.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.IssueIncidentObjectMapTuple} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.IssueIncidentObjectMapTuple.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pangolin.protos.IssueIncidentObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.pangolin.protos.IssueIncidentObjectMapTuple.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.IssueIncidentObjectMapTuple} returns this
 */
proto.pangolin.protos.IssueIncidentObjectMapTuple.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.IssueIncidentObjectMapTuple} returns this
 */
proto.pangolin.protos.IssueIncidentObjectMapTuple.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.IssueIncidentObjectMapTuple.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional IssueIncidentObject data = 2;
 * @return {?proto.pangolin.protos.IssueIncidentObject}
 */
proto.pangolin.protos.IssueIncidentObjectMapTuple.prototype.getData = function() {
  return /** @type{?proto.pangolin.protos.IssueIncidentObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.IssueIncidentObject, 2));
};


/**
 * @param {?proto.pangolin.protos.IssueIncidentObject|undefined} value
 * @return {!proto.pangolin.protos.IssueIncidentObjectMapTuple} returns this
*/
proto.pangolin.protos.IssueIncidentObjectMapTuple.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.IssueIncidentObjectMapTuple} returns this
 */
proto.pangolin.protos.IssueIncidentObjectMapTuple.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.IssueIncidentObjectMapTuple.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.IssueObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.IssueObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.IssueObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.IssueObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    fpid: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    kind: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    data: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    action: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    obsolete: (f = jspb.Message.getBooleanField(msg, 7)) == null ? undefined : f,
    severity: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
    incidents: (f = msg.getIncidents()) && proto.pangolin.protos.IssueIncidentObjectMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.IssueObject}
 */
proto.pangolin.protos.IssueObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.IssueObject;
  return proto.pangolin.protos.IssueObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.IssueObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.IssueObject}
 */
proto.pangolin.protos.IssueObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFpid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setKind(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setData(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAction(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setObsolete(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSeverity(value);
      break;
    case 5:
      var value = new proto.pangolin.protos.IssueIncidentObjectMap;
      reader.readMessage(value,proto.pangolin.protos.IssueIncidentObjectMap.deserializeBinaryFromReader);
      msg.setIncidents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.IssueObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.IssueObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.IssueObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.IssueObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeBool(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getIncidents();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.pangolin.protos.IssueIncidentObjectMap.serializeBinaryToWriter
    );
  }
};


/**
 * optional string fpid = 1;
 * @return {string}
 */
proto.pangolin.protos.IssueObject.prototype.getFpid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.IssueObject} returns this
 */
proto.pangolin.protos.IssueObject.prototype.setFpid = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.IssueObject} returns this
 */
proto.pangolin.protos.IssueObject.prototype.clearFpid = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.IssueObject.prototype.hasFpid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string kind = 2;
 * @return {string}
 */
proto.pangolin.protos.IssueObject.prototype.getKind = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.IssueObject} returns this
 */
proto.pangolin.protos.IssueObject.prototype.setKind = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.IssueObject} returns this
 */
proto.pangolin.protos.IssueObject.prototype.clearKind = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.IssueObject.prototype.hasKind = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string data = 3;
 * @return {string}
 */
proto.pangolin.protos.IssueObject.prototype.getData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.IssueObject} returns this
 */
proto.pangolin.protos.IssueObject.prototype.setData = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.IssueObject} returns this
 */
proto.pangolin.protos.IssueObject.prototype.clearData = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.IssueObject.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string action = 4;
 * @return {string}
 */
proto.pangolin.protos.IssueObject.prototype.getAction = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.IssueObject} returns this
 */
proto.pangolin.protos.IssueObject.prototype.setAction = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.IssueObject} returns this
 */
proto.pangolin.protos.IssueObject.prototype.clearAction = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.IssueObject.prototype.hasAction = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool obsolete = 7;
 * @return {boolean}
 */
proto.pangolin.protos.IssueObject.prototype.getObsolete = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.IssueObject} returns this
 */
proto.pangolin.protos.IssueObject.prototype.setObsolete = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.IssueObject} returns this
 */
proto.pangolin.protos.IssueObject.prototype.clearObsolete = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.IssueObject.prototype.hasObsolete = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional uint32 severity = 6;
 * @return {number}
 */
proto.pangolin.protos.IssueObject.prototype.getSeverity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.IssueObject} returns this
 */
proto.pangolin.protos.IssueObject.prototype.setSeverity = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.IssueObject} returns this
 */
proto.pangolin.protos.IssueObject.prototype.clearSeverity = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.IssueObject.prototype.hasSeverity = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional IssueIncidentObjectMap incidents = 5;
 * @return {?proto.pangolin.protos.IssueIncidentObjectMap}
 */
proto.pangolin.protos.IssueObject.prototype.getIncidents = function() {
  return /** @type{?proto.pangolin.protos.IssueIncidentObjectMap} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.IssueIncidentObjectMap, 5));
};


/**
 * @param {?proto.pangolin.protos.IssueIncidentObjectMap|undefined} value
 * @return {!proto.pangolin.protos.IssueObject} returns this
*/
proto.pangolin.protos.IssueObject.prototype.setIncidents = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.IssueObject} returns this
 */
proto.pangolin.protos.IssueObject.prototype.clearIncidents = function() {
  return this.setIncidents(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.IssueObject.prototype.hasIncidents = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.IssueObjectMap.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.IssueObjectMap.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.IssueObjectMap.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.IssueObjectMap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.IssueObjectMap.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.pangolin.protos.IssueObjectMapTuple.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.IssueObjectMap}
 */
proto.pangolin.protos.IssueObjectMap.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.IssueObjectMap;
  return proto.pangolin.protos.IssueObjectMap.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.IssueObjectMap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.IssueObjectMap}
 */
proto.pangolin.protos.IssueObjectMap.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.IssueObjectMapTuple;
      reader.readMessage(value,proto.pangolin.protos.IssueObjectMapTuple.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.IssueObjectMap.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.IssueObjectMap.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.IssueObjectMap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.IssueObjectMap.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pangolin.protos.IssueObjectMapTuple.serializeBinaryToWriter
    );
  }
};


/**
 * repeated IssueObjectMapTuple items = 1;
 * @return {!Array<!proto.pangolin.protos.IssueObjectMapTuple>}
 */
proto.pangolin.protos.IssueObjectMap.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.pangolin.protos.IssueObjectMapTuple>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pangolin.protos.IssueObjectMapTuple, 1));
};


/**
 * @param {!Array<!proto.pangolin.protos.IssueObjectMapTuple>} value
 * @return {!proto.pangolin.protos.IssueObjectMap} returns this
*/
proto.pangolin.protos.IssueObjectMap.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pangolin.protos.IssueObjectMapTuple=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.IssueObjectMapTuple}
 */
proto.pangolin.protos.IssueObjectMap.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pangolin.protos.IssueObjectMapTuple, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.IssueObjectMap} returns this
 */
proto.pangolin.protos.IssueObjectMap.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.IssueObjectMapTuple.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.IssueObjectMapTuple.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.IssueObjectMapTuple} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.IssueObjectMapTuple.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    data: (f = msg.getData()) && proto.pangolin.protos.IssueObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.IssueObjectMapTuple}
 */
proto.pangolin.protos.IssueObjectMapTuple.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.IssueObjectMapTuple;
  return proto.pangolin.protos.IssueObjectMapTuple.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.IssueObjectMapTuple} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.IssueObjectMapTuple}
 */
proto.pangolin.protos.IssueObjectMapTuple.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.pangolin.protos.IssueObject;
      reader.readMessage(value,proto.pangolin.protos.IssueObject.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.IssueObjectMapTuple.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.IssueObjectMapTuple.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.IssueObjectMapTuple} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.IssueObjectMapTuple.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pangolin.protos.IssueObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.pangolin.protos.IssueObjectMapTuple.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.IssueObjectMapTuple} returns this
 */
proto.pangolin.protos.IssueObjectMapTuple.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.IssueObjectMapTuple} returns this
 */
proto.pangolin.protos.IssueObjectMapTuple.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.IssueObjectMapTuple.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional IssueObject data = 2;
 * @return {?proto.pangolin.protos.IssueObject}
 */
proto.pangolin.protos.IssueObjectMapTuple.prototype.getData = function() {
  return /** @type{?proto.pangolin.protos.IssueObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.IssueObject, 2));
};


/**
 * @param {?proto.pangolin.protos.IssueObject|undefined} value
 * @return {!proto.pangolin.protos.IssueObjectMapTuple} returns this
*/
proto.pangolin.protos.IssueObjectMapTuple.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.IssueObjectMapTuple} returns this
 */
proto.pangolin.protos.IssueObjectMapTuple.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.IssueObjectMapTuple.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.IssueIncidentError.repeatedFields_ = [1,2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.IssueIncidentError.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.IssueIncidentError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.IssueIncidentError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.IssueIncidentError.toObject = function(includeInstance, msg) {
  var f, obj = {
    uuidList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    timestampList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    seenList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.IssueIncidentError}
 */
proto.pangolin.protos.IssueIncidentError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.IssueIncidentError;
  return proto.pangolin.protos.IssueIncidentError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.IssueIncidentError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.IssueIncidentError}
 */
proto.pangolin.protos.IssueIncidentError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addTimestamp(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addSeen(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.IssueIncidentError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.IssueIncidentError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.IssueIncidentError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.IssueIncidentError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuidList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getTimestampList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getSeenList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * repeated string uuid = 1;
 * @return {!Array<string>}
 */
proto.pangolin.protos.IssueIncidentError.prototype.getUuidList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.IssueIncidentError} returns this
 */
proto.pangolin.protos.IssueIncidentError.prototype.setUuidList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.IssueIncidentError} returns this
 */
proto.pangolin.protos.IssueIncidentError.prototype.addUuid = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.IssueIncidentError} returns this
 */
proto.pangolin.protos.IssueIncidentError.prototype.clearUuidList = function() {
  return this.setUuidList([]);
};


/**
 * repeated string timestamp = 2;
 * @return {!Array<string>}
 */
proto.pangolin.protos.IssueIncidentError.prototype.getTimestampList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.IssueIncidentError} returns this
 */
proto.pangolin.protos.IssueIncidentError.prototype.setTimestampList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.IssueIncidentError} returns this
 */
proto.pangolin.protos.IssueIncidentError.prototype.addTimestamp = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.IssueIncidentError} returns this
 */
proto.pangolin.protos.IssueIncidentError.prototype.clearTimestampList = function() {
  return this.setTimestampList([]);
};


/**
 * repeated string seen = 3;
 * @return {!Array<string>}
 */
proto.pangolin.protos.IssueIncidentError.prototype.getSeenList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.IssueIncidentError} returns this
 */
proto.pangolin.protos.IssueIncidentError.prototype.setSeenList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.IssueIncidentError} returns this
 */
proto.pangolin.protos.IssueIncidentError.prototype.addSeen = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.IssueIncidentError} returns this
 */
proto.pangolin.protos.IssueIncidentError.prototype.clearSeenList = function() {
  return this.setSeenList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.IssueIncidentErrorMap.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.IssueIncidentErrorMap.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.IssueIncidentErrorMap.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.IssueIncidentErrorMap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.IssueIncidentErrorMap.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.pangolin.protos.IssueIncidentErrorMapTuple.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.IssueIncidentErrorMap}
 */
proto.pangolin.protos.IssueIncidentErrorMap.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.IssueIncidentErrorMap;
  return proto.pangolin.protos.IssueIncidentErrorMap.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.IssueIncidentErrorMap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.IssueIncidentErrorMap}
 */
proto.pangolin.protos.IssueIncidentErrorMap.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.IssueIncidentErrorMapTuple;
      reader.readMessage(value,proto.pangolin.protos.IssueIncidentErrorMapTuple.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.IssueIncidentErrorMap.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.IssueIncidentErrorMap.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.IssueIncidentErrorMap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.IssueIncidentErrorMap.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pangolin.protos.IssueIncidentErrorMapTuple.serializeBinaryToWriter
    );
  }
};


/**
 * repeated IssueIncidentErrorMapTuple items = 1;
 * @return {!Array<!proto.pangolin.protos.IssueIncidentErrorMapTuple>}
 */
proto.pangolin.protos.IssueIncidentErrorMap.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.pangolin.protos.IssueIncidentErrorMapTuple>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pangolin.protos.IssueIncidentErrorMapTuple, 1));
};


/**
 * @param {!Array<!proto.pangolin.protos.IssueIncidentErrorMapTuple>} value
 * @return {!proto.pangolin.protos.IssueIncidentErrorMap} returns this
*/
proto.pangolin.protos.IssueIncidentErrorMap.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pangolin.protos.IssueIncidentErrorMapTuple=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.IssueIncidentErrorMapTuple}
 */
proto.pangolin.protos.IssueIncidentErrorMap.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pangolin.protos.IssueIncidentErrorMapTuple, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.IssueIncidentErrorMap} returns this
 */
proto.pangolin.protos.IssueIncidentErrorMap.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.IssueIncidentErrorMapTuple.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.IssueIncidentErrorMapTuple.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.IssueIncidentErrorMapTuple} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.IssueIncidentErrorMapTuple.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    error: (f = msg.getError()) && proto.pangolin.protos.IssueIncidentError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.IssueIncidentErrorMapTuple}
 */
proto.pangolin.protos.IssueIncidentErrorMapTuple.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.IssueIncidentErrorMapTuple;
  return proto.pangolin.protos.IssueIncidentErrorMapTuple.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.IssueIncidentErrorMapTuple} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.IssueIncidentErrorMapTuple}
 */
proto.pangolin.protos.IssueIncidentErrorMapTuple.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.pangolin.protos.IssueIncidentError;
      reader.readMessage(value,proto.pangolin.protos.IssueIncidentError.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.IssueIncidentErrorMapTuple.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.IssueIncidentErrorMapTuple.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.IssueIncidentErrorMapTuple} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.IssueIncidentErrorMapTuple.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pangolin.protos.IssueIncidentError.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.pangolin.protos.IssueIncidentErrorMapTuple.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.IssueIncidentErrorMapTuple} returns this
 */
proto.pangolin.protos.IssueIncidentErrorMapTuple.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.IssueIncidentErrorMapTuple} returns this
 */
proto.pangolin.protos.IssueIncidentErrorMapTuple.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.IssueIncidentErrorMapTuple.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional IssueIncidentError error = 2;
 * @return {?proto.pangolin.protos.IssueIncidentError}
 */
proto.pangolin.protos.IssueIncidentErrorMapTuple.prototype.getError = function() {
  return /** @type{?proto.pangolin.protos.IssueIncidentError} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.IssueIncidentError, 2));
};


/**
 * @param {?proto.pangolin.protos.IssueIncidentError|undefined} value
 * @return {!proto.pangolin.protos.IssueIncidentErrorMapTuple} returns this
*/
proto.pangolin.protos.IssueIncidentErrorMapTuple.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.IssueIncidentErrorMapTuple} returns this
 */
proto.pangolin.protos.IssueIncidentErrorMapTuple.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.IssueIncidentErrorMapTuple.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.IssueError.repeatedFields_ = [1,2,3,4,7,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.IssueError.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.IssueError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.IssueError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.IssueError.toObject = function(includeInstance, msg) {
  var f, obj = {
    fpidList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    kindList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    dataList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    actionList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    obsoleteList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    severityList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    incidents: (f = msg.getIncidents()) && proto.pangolin.protos.IssueIncidentErrorMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.IssueError}
 */
proto.pangolin.protos.IssueError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.IssueError;
  return proto.pangolin.protos.IssueError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.IssueError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.IssueError}
 */
proto.pangolin.protos.IssueError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addFpid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addKind(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addData(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addAction(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addObsolete(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addSeverity(value);
      break;
    case 5:
      var value = new proto.pangolin.protos.IssueIncidentErrorMap;
      reader.readMessage(value,proto.pangolin.protos.IssueIncidentErrorMap.deserializeBinaryFromReader);
      msg.setIncidents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.IssueError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.IssueError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.IssueError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.IssueError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFpidList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getKindList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getActionList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getObsoleteList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getSeverityList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getIncidents();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.pangolin.protos.IssueIncidentErrorMap.serializeBinaryToWriter
    );
  }
};


/**
 * repeated string fpid = 1;
 * @return {!Array<string>}
 */
proto.pangolin.protos.IssueError.prototype.getFpidList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.IssueError} returns this
 */
proto.pangolin.protos.IssueError.prototype.setFpidList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.IssueError} returns this
 */
proto.pangolin.protos.IssueError.prototype.addFpid = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.IssueError} returns this
 */
proto.pangolin.protos.IssueError.prototype.clearFpidList = function() {
  return this.setFpidList([]);
};


/**
 * repeated string kind = 2;
 * @return {!Array<string>}
 */
proto.pangolin.protos.IssueError.prototype.getKindList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.IssueError} returns this
 */
proto.pangolin.protos.IssueError.prototype.setKindList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.IssueError} returns this
 */
proto.pangolin.protos.IssueError.prototype.addKind = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.IssueError} returns this
 */
proto.pangolin.protos.IssueError.prototype.clearKindList = function() {
  return this.setKindList([]);
};


/**
 * repeated string data = 3;
 * @return {!Array<string>}
 */
proto.pangolin.protos.IssueError.prototype.getDataList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.IssueError} returns this
 */
proto.pangolin.protos.IssueError.prototype.setDataList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.IssueError} returns this
 */
proto.pangolin.protos.IssueError.prototype.addData = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.IssueError} returns this
 */
proto.pangolin.protos.IssueError.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * repeated string action = 4;
 * @return {!Array<string>}
 */
proto.pangolin.protos.IssueError.prototype.getActionList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.IssueError} returns this
 */
proto.pangolin.protos.IssueError.prototype.setActionList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.IssueError} returns this
 */
proto.pangolin.protos.IssueError.prototype.addAction = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.IssueError} returns this
 */
proto.pangolin.protos.IssueError.prototype.clearActionList = function() {
  return this.setActionList([]);
};


/**
 * repeated string obsolete = 7;
 * @return {!Array<string>}
 */
proto.pangolin.protos.IssueError.prototype.getObsoleteList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.IssueError} returns this
 */
proto.pangolin.protos.IssueError.prototype.setObsoleteList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.IssueError} returns this
 */
proto.pangolin.protos.IssueError.prototype.addObsolete = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.IssueError} returns this
 */
proto.pangolin.protos.IssueError.prototype.clearObsoleteList = function() {
  return this.setObsoleteList([]);
};


/**
 * repeated string severity = 6;
 * @return {!Array<string>}
 */
proto.pangolin.protos.IssueError.prototype.getSeverityList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.IssueError} returns this
 */
proto.pangolin.protos.IssueError.prototype.setSeverityList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.IssueError} returns this
 */
proto.pangolin.protos.IssueError.prototype.addSeverity = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.IssueError} returns this
 */
proto.pangolin.protos.IssueError.prototype.clearSeverityList = function() {
  return this.setSeverityList([]);
};


/**
 * optional IssueIncidentErrorMap incidents = 5;
 * @return {?proto.pangolin.protos.IssueIncidentErrorMap}
 */
proto.pangolin.protos.IssueError.prototype.getIncidents = function() {
  return /** @type{?proto.pangolin.protos.IssueIncidentErrorMap} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.IssueIncidentErrorMap, 5));
};


/**
 * @param {?proto.pangolin.protos.IssueIncidentErrorMap|undefined} value
 * @return {!proto.pangolin.protos.IssueError} returns this
*/
proto.pangolin.protos.IssueError.prototype.setIncidents = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.IssueError} returns this
 */
proto.pangolin.protos.IssueError.prototype.clearIncidents = function() {
  return this.setIncidents(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.IssueError.prototype.hasIncidents = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.IssueErrorMap.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.IssueErrorMap.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.IssueErrorMap.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.IssueErrorMap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.IssueErrorMap.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.pangolin.protos.IssueErrorMapTuple.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.IssueErrorMap}
 */
proto.pangolin.protos.IssueErrorMap.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.IssueErrorMap;
  return proto.pangolin.protos.IssueErrorMap.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.IssueErrorMap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.IssueErrorMap}
 */
proto.pangolin.protos.IssueErrorMap.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.IssueErrorMapTuple;
      reader.readMessage(value,proto.pangolin.protos.IssueErrorMapTuple.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.IssueErrorMap.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.IssueErrorMap.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.IssueErrorMap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.IssueErrorMap.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pangolin.protos.IssueErrorMapTuple.serializeBinaryToWriter
    );
  }
};


/**
 * repeated IssueErrorMapTuple items = 1;
 * @return {!Array<!proto.pangolin.protos.IssueErrorMapTuple>}
 */
proto.pangolin.protos.IssueErrorMap.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.pangolin.protos.IssueErrorMapTuple>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pangolin.protos.IssueErrorMapTuple, 1));
};


/**
 * @param {!Array<!proto.pangolin.protos.IssueErrorMapTuple>} value
 * @return {!proto.pangolin.protos.IssueErrorMap} returns this
*/
proto.pangolin.protos.IssueErrorMap.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pangolin.protos.IssueErrorMapTuple=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.IssueErrorMapTuple}
 */
proto.pangolin.protos.IssueErrorMap.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pangolin.protos.IssueErrorMapTuple, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.IssueErrorMap} returns this
 */
proto.pangolin.protos.IssueErrorMap.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.IssueErrorMapTuple.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.IssueErrorMapTuple.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.IssueErrorMapTuple} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.IssueErrorMapTuple.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    error: (f = msg.getError()) && proto.pangolin.protos.IssueError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.IssueErrorMapTuple}
 */
proto.pangolin.protos.IssueErrorMapTuple.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.IssueErrorMapTuple;
  return proto.pangolin.protos.IssueErrorMapTuple.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.IssueErrorMapTuple} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.IssueErrorMapTuple}
 */
proto.pangolin.protos.IssueErrorMapTuple.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.pangolin.protos.IssueError;
      reader.readMessage(value,proto.pangolin.protos.IssueError.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.IssueErrorMapTuple.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.IssueErrorMapTuple.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.IssueErrorMapTuple} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.IssueErrorMapTuple.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pangolin.protos.IssueError.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.pangolin.protos.IssueErrorMapTuple.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.IssueErrorMapTuple} returns this
 */
proto.pangolin.protos.IssueErrorMapTuple.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.IssueErrorMapTuple} returns this
 */
proto.pangolin.protos.IssueErrorMapTuple.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.IssueErrorMapTuple.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional IssueError error = 2;
 * @return {?proto.pangolin.protos.IssueError}
 */
proto.pangolin.protos.IssueErrorMapTuple.prototype.getError = function() {
  return /** @type{?proto.pangolin.protos.IssueError} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.IssueError, 2));
};


/**
 * @param {?proto.pangolin.protos.IssueError|undefined} value
 * @return {!proto.pangolin.protos.IssueErrorMapTuple} returns this
*/
proto.pangolin.protos.IssueErrorMapTuple.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.IssueErrorMapTuple} returns this
 */
proto.pangolin.protos.IssueErrorMapTuple.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.IssueErrorMapTuple.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.GetIssuesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.GetIssuesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.GetIssuesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetIssuesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    issues: (f = msg.getIssues()) && proto.pangolin.protos.IssueObjectMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.GetIssuesResponse}
 */
proto.pangolin.protos.GetIssuesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.GetIssuesResponse;
  return proto.pangolin.protos.GetIssuesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.GetIssuesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.GetIssuesResponse}
 */
proto.pangolin.protos.GetIssuesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.IssueObjectMap;
      reader.readMessage(value,proto.pangolin.protos.IssueObjectMap.deserializeBinaryFromReader);
      msg.setIssues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.GetIssuesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.GetIssuesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.GetIssuesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetIssuesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIssues();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.IssueObjectMap.serializeBinaryToWriter
    );
  }
};


/**
 * required IssueObjectMap issues = 1;
 * @return {!proto.pangolin.protos.IssueObjectMap}
 */
proto.pangolin.protos.GetIssuesResponse.prototype.getIssues = function() {
  return /** @type{!proto.pangolin.protos.IssueObjectMap} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.IssueObjectMap, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.IssueObjectMap} value
 * @return {!proto.pangolin.protos.GetIssuesResponse} returns this
*/
proto.pangolin.protos.GetIssuesResponse.prototype.setIssues = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.GetIssuesResponse} returns this
 */
proto.pangolin.protos.GetIssuesResponse.prototype.clearIssues = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.GetIssuesResponse.prototype.hasIssues = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SetIssuesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SetIssuesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SetIssuesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetIssuesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    issues: (f = msg.getIssues()) && proto.pangolin.protos.IssueObjectMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SetIssuesRequest}
 */
proto.pangolin.protos.SetIssuesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SetIssuesRequest;
  return proto.pangolin.protos.SetIssuesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SetIssuesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SetIssuesRequest}
 */
proto.pangolin.protos.SetIssuesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.IssueObjectMap;
      reader.readMessage(value,proto.pangolin.protos.IssueObjectMap.deserializeBinaryFromReader);
      msg.setIssues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SetIssuesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SetIssuesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SetIssuesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetIssuesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIssues();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.IssueObjectMap.serializeBinaryToWriter
    );
  }
};


/**
 * required IssueObjectMap issues = 1;
 * @return {!proto.pangolin.protos.IssueObjectMap}
 */
proto.pangolin.protos.SetIssuesRequest.prototype.getIssues = function() {
  return /** @type{!proto.pangolin.protos.IssueObjectMap} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.IssueObjectMap, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.IssueObjectMap} value
 * @return {!proto.pangolin.protos.SetIssuesRequest} returns this
*/
proto.pangolin.protos.SetIssuesRequest.prototype.setIssues = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.SetIssuesRequest} returns this
 */
proto.pangolin.protos.SetIssuesRequest.prototype.clearIssues = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SetIssuesRequest.prototype.hasIssues = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SetIssuesResponseInvalid.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SetIssuesResponseInvalid.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SetIssuesResponseInvalid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetIssuesResponseInvalid.toObject = function(includeInstance, msg) {
  var f, obj = {
    issues: (f = msg.getIssues()) && proto.pangolin.protos.IssueErrorMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SetIssuesResponseInvalid}
 */
proto.pangolin.protos.SetIssuesResponseInvalid.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SetIssuesResponseInvalid;
  return proto.pangolin.protos.SetIssuesResponseInvalid.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SetIssuesResponseInvalid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SetIssuesResponseInvalid}
 */
proto.pangolin.protos.SetIssuesResponseInvalid.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.IssueErrorMap;
      reader.readMessage(value,proto.pangolin.protos.IssueErrorMap.deserializeBinaryFromReader);
      msg.setIssues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SetIssuesResponseInvalid.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SetIssuesResponseInvalid.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SetIssuesResponseInvalid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetIssuesResponseInvalid.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIssues();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.IssueErrorMap.serializeBinaryToWriter
    );
  }
};


/**
 * required IssueErrorMap issues = 1;
 * @return {!proto.pangolin.protos.IssueErrorMap}
 */
proto.pangolin.protos.SetIssuesResponseInvalid.prototype.getIssues = function() {
  return /** @type{!proto.pangolin.protos.IssueErrorMap} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.IssueErrorMap, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.IssueErrorMap} value
 * @return {!proto.pangolin.protos.SetIssuesResponseInvalid} returns this
*/
proto.pangolin.protos.SetIssuesResponseInvalid.prototype.setIssues = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.SetIssuesResponseInvalid} returns this
 */
proto.pangolin.protos.SetIssuesResponseInvalid.prototype.clearIssues = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SetIssuesResponseInvalid.prototype.hasIssues = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.GetIssueResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.GetIssueResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.GetIssueResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetIssueResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    issue: (f = msg.getIssue()) && proto.pangolin.protos.IssueObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.GetIssueResponse}
 */
proto.pangolin.protos.GetIssueResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.GetIssueResponse;
  return proto.pangolin.protos.GetIssueResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.GetIssueResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.GetIssueResponse}
 */
proto.pangolin.protos.GetIssueResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.IssueObject;
      reader.readMessage(value,proto.pangolin.protos.IssueObject.deserializeBinaryFromReader);
      msg.setIssue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.GetIssueResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.GetIssueResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.GetIssueResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetIssueResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIssue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.IssueObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional IssueObject issue = 1;
 * @return {?proto.pangolin.protos.IssueObject}
 */
proto.pangolin.protos.GetIssueResponse.prototype.getIssue = function() {
  return /** @type{?proto.pangolin.protos.IssueObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.IssueObject, 1));
};


/**
 * @param {?proto.pangolin.protos.IssueObject|undefined} value
 * @return {!proto.pangolin.protos.GetIssueResponse} returns this
*/
proto.pangolin.protos.GetIssueResponse.prototype.setIssue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.GetIssueResponse} returns this
 */
proto.pangolin.protos.GetIssueResponse.prototype.clearIssue = function() {
  return this.setIssue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.GetIssueResponse.prototype.hasIssue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SetIssueRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SetIssueRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SetIssueRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetIssueRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    issue: (f = msg.getIssue()) && proto.pangolin.protos.IssueObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SetIssueRequest}
 */
proto.pangolin.protos.SetIssueRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SetIssueRequest;
  return proto.pangolin.protos.SetIssueRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SetIssueRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SetIssueRequest}
 */
proto.pangolin.protos.SetIssueRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.IssueObject;
      reader.readMessage(value,proto.pangolin.protos.IssueObject.deserializeBinaryFromReader);
      msg.setIssue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SetIssueRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SetIssueRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SetIssueRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetIssueRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIssue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.IssueObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional IssueObject issue = 1;
 * @return {?proto.pangolin.protos.IssueObject}
 */
proto.pangolin.protos.SetIssueRequest.prototype.getIssue = function() {
  return /** @type{?proto.pangolin.protos.IssueObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.IssueObject, 1));
};


/**
 * @param {?proto.pangolin.protos.IssueObject|undefined} value
 * @return {!proto.pangolin.protos.SetIssueRequest} returns this
*/
proto.pangolin.protos.SetIssueRequest.prototype.setIssue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.SetIssueRequest} returns this
 */
proto.pangolin.protos.SetIssueRequest.prototype.clearIssue = function() {
  return this.setIssue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SetIssueRequest.prototype.hasIssue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SetIssueResponseInvalid.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SetIssueResponseInvalid.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SetIssueResponseInvalid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetIssueResponseInvalid.toObject = function(includeInstance, msg) {
  var f, obj = {
    issue: (f = msg.getIssue()) && proto.pangolin.protos.IssueError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SetIssueResponseInvalid}
 */
proto.pangolin.protos.SetIssueResponseInvalid.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SetIssueResponseInvalid;
  return proto.pangolin.protos.SetIssueResponseInvalid.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SetIssueResponseInvalid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SetIssueResponseInvalid}
 */
proto.pangolin.protos.SetIssueResponseInvalid.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.IssueError;
      reader.readMessage(value,proto.pangolin.protos.IssueError.deserializeBinaryFromReader);
      msg.setIssue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SetIssueResponseInvalid.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SetIssueResponseInvalid.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SetIssueResponseInvalid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetIssueResponseInvalid.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIssue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.IssueError.serializeBinaryToWriter
    );
  }
};


/**
 * optional IssueError issue = 1;
 * @return {?proto.pangolin.protos.IssueError}
 */
proto.pangolin.protos.SetIssueResponseInvalid.prototype.getIssue = function() {
  return /** @type{?proto.pangolin.protos.IssueError} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.IssueError, 1));
};


/**
 * @param {?proto.pangolin.protos.IssueError|undefined} value
 * @return {!proto.pangolin.protos.SetIssueResponseInvalid} returns this
*/
proto.pangolin.protos.SetIssueResponseInvalid.prototype.setIssue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.SetIssueResponseInvalid} returns this
 */
proto.pangolin.protos.SetIssueResponseInvalid.prototype.clearIssue = function() {
  return this.setIssue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SetIssueResponseInvalid.prototype.hasIssue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.GetIssueIncidentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.GetIssueIncidentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.GetIssueIncidentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetIssueIncidentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    incidents: (f = msg.getIncidents()) && proto.pangolin.protos.IssueIncidentObjectMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.GetIssueIncidentsResponse}
 */
proto.pangolin.protos.GetIssueIncidentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.GetIssueIncidentsResponse;
  return proto.pangolin.protos.GetIssueIncidentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.GetIssueIncidentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.GetIssueIncidentsResponse}
 */
proto.pangolin.protos.GetIssueIncidentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.IssueIncidentObjectMap;
      reader.readMessage(value,proto.pangolin.protos.IssueIncidentObjectMap.deserializeBinaryFromReader);
      msg.setIncidents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.GetIssueIncidentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.GetIssueIncidentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.GetIssueIncidentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetIssueIncidentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIncidents();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.IssueIncidentObjectMap.serializeBinaryToWriter
    );
  }
};


/**
 * required IssueIncidentObjectMap incidents = 1;
 * @return {!proto.pangolin.protos.IssueIncidentObjectMap}
 */
proto.pangolin.protos.GetIssueIncidentsResponse.prototype.getIncidents = function() {
  return /** @type{!proto.pangolin.protos.IssueIncidentObjectMap} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.IssueIncidentObjectMap, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.IssueIncidentObjectMap} value
 * @return {!proto.pangolin.protos.GetIssueIncidentsResponse} returns this
*/
proto.pangolin.protos.GetIssueIncidentsResponse.prototype.setIncidents = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.GetIssueIncidentsResponse} returns this
 */
proto.pangolin.protos.GetIssueIncidentsResponse.prototype.clearIncidents = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.GetIssueIncidentsResponse.prototype.hasIncidents = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SetIssueIncidentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SetIssueIncidentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SetIssueIncidentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetIssueIncidentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    incidents: (f = msg.getIncidents()) && proto.pangolin.protos.IssueIncidentObjectMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SetIssueIncidentsRequest}
 */
proto.pangolin.protos.SetIssueIncidentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SetIssueIncidentsRequest;
  return proto.pangolin.protos.SetIssueIncidentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SetIssueIncidentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SetIssueIncidentsRequest}
 */
proto.pangolin.protos.SetIssueIncidentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.IssueIncidentObjectMap;
      reader.readMessage(value,proto.pangolin.protos.IssueIncidentObjectMap.deserializeBinaryFromReader);
      msg.setIncidents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SetIssueIncidentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SetIssueIncidentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SetIssueIncidentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetIssueIncidentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIncidents();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.IssueIncidentObjectMap.serializeBinaryToWriter
    );
  }
};


/**
 * required IssueIncidentObjectMap incidents = 1;
 * @return {!proto.pangolin.protos.IssueIncidentObjectMap}
 */
proto.pangolin.protos.SetIssueIncidentsRequest.prototype.getIncidents = function() {
  return /** @type{!proto.pangolin.protos.IssueIncidentObjectMap} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.IssueIncidentObjectMap, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.IssueIncidentObjectMap} value
 * @return {!proto.pangolin.protos.SetIssueIncidentsRequest} returns this
*/
proto.pangolin.protos.SetIssueIncidentsRequest.prototype.setIncidents = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.SetIssueIncidentsRequest} returns this
 */
proto.pangolin.protos.SetIssueIncidentsRequest.prototype.clearIncidents = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SetIssueIncidentsRequest.prototype.hasIncidents = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SetIssueIncidentsResponseInvalid.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SetIssueIncidentsResponseInvalid.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SetIssueIncidentsResponseInvalid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetIssueIncidentsResponseInvalid.toObject = function(includeInstance, msg) {
  var f, obj = {
    incidents: (f = msg.getIncidents()) && proto.pangolin.protos.IssueIncidentErrorMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SetIssueIncidentsResponseInvalid}
 */
proto.pangolin.protos.SetIssueIncidentsResponseInvalid.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SetIssueIncidentsResponseInvalid;
  return proto.pangolin.protos.SetIssueIncidentsResponseInvalid.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SetIssueIncidentsResponseInvalid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SetIssueIncidentsResponseInvalid}
 */
proto.pangolin.protos.SetIssueIncidentsResponseInvalid.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.IssueIncidentErrorMap;
      reader.readMessage(value,proto.pangolin.protos.IssueIncidentErrorMap.deserializeBinaryFromReader);
      msg.setIncidents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SetIssueIncidentsResponseInvalid.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SetIssueIncidentsResponseInvalid.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SetIssueIncidentsResponseInvalid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetIssueIncidentsResponseInvalid.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIncidents();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.IssueIncidentErrorMap.serializeBinaryToWriter
    );
  }
};


/**
 * required IssueIncidentErrorMap incidents = 1;
 * @return {!proto.pangolin.protos.IssueIncidentErrorMap}
 */
proto.pangolin.protos.SetIssueIncidentsResponseInvalid.prototype.getIncidents = function() {
  return /** @type{!proto.pangolin.protos.IssueIncidentErrorMap} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.IssueIncidentErrorMap, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.IssueIncidentErrorMap} value
 * @return {!proto.pangolin.protos.SetIssueIncidentsResponseInvalid} returns this
*/
proto.pangolin.protos.SetIssueIncidentsResponseInvalid.prototype.setIncidents = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.SetIssueIncidentsResponseInvalid} returns this
 */
proto.pangolin.protos.SetIssueIncidentsResponseInvalid.prototype.clearIncidents = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SetIssueIncidentsResponseInvalid.prototype.hasIncidents = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.GetIssueIncidentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.GetIssueIncidentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.GetIssueIncidentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetIssueIncidentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    incident: (f = msg.getIncident()) && proto.pangolin.protos.IssueIncidentObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.GetIssueIncidentResponse}
 */
proto.pangolin.protos.GetIssueIncidentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.GetIssueIncidentResponse;
  return proto.pangolin.protos.GetIssueIncidentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.GetIssueIncidentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.GetIssueIncidentResponse}
 */
proto.pangolin.protos.GetIssueIncidentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.IssueIncidentObject;
      reader.readMessage(value,proto.pangolin.protos.IssueIncidentObject.deserializeBinaryFromReader);
      msg.setIncident(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.GetIssueIncidentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.GetIssueIncidentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.GetIssueIncidentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetIssueIncidentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIncident();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.IssueIncidentObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional IssueIncidentObject incident = 1;
 * @return {?proto.pangolin.protos.IssueIncidentObject}
 */
proto.pangolin.protos.GetIssueIncidentResponse.prototype.getIncident = function() {
  return /** @type{?proto.pangolin.protos.IssueIncidentObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.IssueIncidentObject, 1));
};


/**
 * @param {?proto.pangolin.protos.IssueIncidentObject|undefined} value
 * @return {!proto.pangolin.protos.GetIssueIncidentResponse} returns this
*/
proto.pangolin.protos.GetIssueIncidentResponse.prototype.setIncident = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.GetIssueIncidentResponse} returns this
 */
proto.pangolin.protos.GetIssueIncidentResponse.prototype.clearIncident = function() {
  return this.setIncident(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.GetIssueIncidentResponse.prototype.hasIncident = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SetIssueIncidentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SetIssueIncidentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SetIssueIncidentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetIssueIncidentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    incident: (f = msg.getIncident()) && proto.pangolin.protos.IssueIncidentObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SetIssueIncidentRequest}
 */
proto.pangolin.protos.SetIssueIncidentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SetIssueIncidentRequest;
  return proto.pangolin.protos.SetIssueIncidentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SetIssueIncidentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SetIssueIncidentRequest}
 */
proto.pangolin.protos.SetIssueIncidentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.IssueIncidentObject;
      reader.readMessage(value,proto.pangolin.protos.IssueIncidentObject.deserializeBinaryFromReader);
      msg.setIncident(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SetIssueIncidentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SetIssueIncidentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SetIssueIncidentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetIssueIncidentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIncident();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.IssueIncidentObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional IssueIncidentObject incident = 1;
 * @return {?proto.pangolin.protos.IssueIncidentObject}
 */
proto.pangolin.protos.SetIssueIncidentRequest.prototype.getIncident = function() {
  return /** @type{?proto.pangolin.protos.IssueIncidentObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.IssueIncidentObject, 1));
};


/**
 * @param {?proto.pangolin.protos.IssueIncidentObject|undefined} value
 * @return {!proto.pangolin.protos.SetIssueIncidentRequest} returns this
*/
proto.pangolin.protos.SetIssueIncidentRequest.prototype.setIncident = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.SetIssueIncidentRequest} returns this
 */
proto.pangolin.protos.SetIssueIncidentRequest.prototype.clearIncident = function() {
  return this.setIncident(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SetIssueIncidentRequest.prototype.hasIncident = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SetIssueIncidentResponseInvalid.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SetIssueIncidentResponseInvalid.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SetIssueIncidentResponseInvalid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetIssueIncidentResponseInvalid.toObject = function(includeInstance, msg) {
  var f, obj = {
    incident: (f = msg.getIncident()) && proto.pangolin.protos.IssueIncidentError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SetIssueIncidentResponseInvalid}
 */
proto.pangolin.protos.SetIssueIncidentResponseInvalid.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SetIssueIncidentResponseInvalid;
  return proto.pangolin.protos.SetIssueIncidentResponseInvalid.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SetIssueIncidentResponseInvalid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SetIssueIncidentResponseInvalid}
 */
proto.pangolin.protos.SetIssueIncidentResponseInvalid.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.IssueIncidentError;
      reader.readMessage(value,proto.pangolin.protos.IssueIncidentError.deserializeBinaryFromReader);
      msg.setIncident(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SetIssueIncidentResponseInvalid.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SetIssueIncidentResponseInvalid.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SetIssueIncidentResponseInvalid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetIssueIncidentResponseInvalid.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIncident();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.IssueIncidentError.serializeBinaryToWriter
    );
  }
};


/**
 * optional IssueIncidentError incident = 1;
 * @return {?proto.pangolin.protos.IssueIncidentError}
 */
proto.pangolin.protos.SetIssueIncidentResponseInvalid.prototype.getIncident = function() {
  return /** @type{?proto.pangolin.protos.IssueIncidentError} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.IssueIncidentError, 1));
};


/**
 * @param {?proto.pangolin.protos.IssueIncidentError|undefined} value
 * @return {!proto.pangolin.protos.SetIssueIncidentResponseInvalid} returns this
*/
proto.pangolin.protos.SetIssueIncidentResponseInvalid.prototype.setIncident = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.SetIssueIncidentResponseInvalid} returns this
 */
proto.pangolin.protos.SetIssueIncidentResponseInvalid.prototype.clearIncident = function() {
  return this.setIncident(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SetIssueIncidentResponseInvalid.prototype.hasIncident = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.pangolin.protos);
